'use client';

import { HTMLAttributes } from 'react';
import { Fragment, jsx, jsxs } from 'react/jsx-runtime';
import { Root } from 'hast';
import { toJsxRuntime } from 'hast-util-to-jsx-runtime';
import { refractor } from 'refractor/core';
import tsxSyntax from 'refractor/tsx';

refractor.register(tsxSyntax);

type CodeSnippetProps = {
  code: string;
  postProcess?: (tree: Root) => Root;
};

function CodeSnippet({
  code,
  postProcess,
  className = '',
  ...props
}: CodeSnippetProps & HTMLAttributes<HTMLDivElement>) {
  const tree = refractor.highlight(code, 'tsx');
  const processedTree = postProcess ? postProcess(tree) : tree;
  const reactNode = toJsxRuntime(processedTree, { Fragment, jsxs, jsx });
  return (
    <div {...props} className={`code-snippet ${className}`}>
      <div>{reactNode}</div>
    </div>
  );
}

export { CodeSnippet };
